import { normalize, schema } from 'normalizr';

import type { CapsuleDto } from 'new/stores/capsules/capsules.endpoints';

export const SCHEMA_TYPE_CAPSULES = 'capsules';

export const capsuleSchema = new schema.Entity(
  SCHEMA_TYPE_CAPSULES,
  {},
  {
    idAttribute: (entity: CapsuleDto) => String(entity.id),
  },
);

const capsuleListSchema = [capsuleSchema];

export interface NormalizedCapsules {
  byId: string[];
  entities: Record<string, CapsuleDto>;
}

export function normalizeCapsuleList(items: CapsuleDto[]): NormalizedCapsules {
  const normalized = normalize(items, capsuleListSchema);
  const entitiesByType = normalized.entities as Record<string, Record<string, CapsuleDto>>;
  const capsuleEntities = entitiesByType[SCHEMA_TYPE_CAPSULES];
  const orderedIds = (normalized.result as string[]) ?? [];

  return {
    byId: orderedIds,
    entities: capsuleEntities ?? {},
  };
}
